import { useCallback, useLayoutEffect } from 'react';
import { useAppDispatch } from 'src/AppContext';
import { userLogin } from 'src/services/api';
import { useUser } from 'src/UserContext';
import { useTranslation } from 'react-i18next';
import useCustomHistory from 'src/hooks/useCustomHistory';
import { useLocation } from 'react-router-dom';
import { parse } from 'querystring';
import { useModal } from 'src/ModalContext';
import LoginView from './View';
import { get } from 'lodash';

export default function Login(): JSX.Element {
  const { t } = useTranslation();
  const location = useLocation();
  const qs = location.search.replace(/^[?]/gi, '');
  const { afterLoginEndpoint } = parse(qs);
  const history = useCustomHistory();
  const dispatch = useAppDispatch();
  const { login, logout } = useUser();
  const { showModal } = useModal();

  // 폼 sumit -> ajax 요청으로 대체
  const onSubmit = useCallback(
    async (e) => {
      userLogin({
        email: e.target.email.value.trim(),
        password: e.target.password.value,
      })
        .then((res) => {
          login(res);
          if (afterLoginEndpoint) {
            const urls = (afterLoginEndpoint as string).split('?');
            history.push(urls[0] ? urls[0] : '/', urls[1] && urls[1].length > 0 ? (parse(urls[1]) as Record<string, string>) : null, [
              'afterLoginEndpoint',
              'beforeLoginEndpoint',
            ]);
          } else {
            history.push('/', {}, ['afterLoginEndpoint', 'beforeLoginEndpoint']);
          }
        })
        .catch((e) => {
          logout();
          const code = get(e, 'response.data.code');
          switch (code) {
            case 'USER_NOT_FOUND':
              showModal({
                message: t('login/login_fail'),
                success: () => {
                  return;
                },
              });
              break;
            case 'NOT_VERIFIED_USER':
              history.push('/email-link', e.response.data.data);
              break;
          }
        });
    },
    [history],
  );

  useLayoutEffect(() => {
    dispatch({ type: 'SET_GNB_LEFT', name: 'back' });
    dispatch({ type: 'SET_GNB_RIGHT', name: 'hidden' });
    dispatch({ type: 'SET_GNB_CENTER', isShow: false });
    return () => {
      dispatch({ type: 'RESET_GNB_LEFT' });
      dispatch({ type: 'RESET_GNB_RIGHT' });
      dispatch({ type: 'SET_GNB_CENTER', isShow: true });
    };
  }, []);

  return <LoginView isShowAutoLogin={true} onSubmit={onSubmit} />;
}
